import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { DiscountDAO } from '../../../../core/services/dao/discountDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class CouponsResolve implements Resolve<any> {
  constructor(
    private userDAO: UserDAO,
    private roleDAO: RoleDAO,
    private discountDAO: DiscountDAO,
    private authService: AuthService,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const discountResolve = this.discountDAO.load();
    const sessionResolve = this.authService.checkSession();
    const mergeResolve = merge(sessionResolve, discountResolve);
    return mergeResolve.pipe(
      take(2),
      map((data) => data),
    );
  }
}
